<template>
    <div class="flex overflow-hidden relative">
        <aside :class="{ 'transform -translate-x-full':!showsidebar }" class="h-screen bg-black text-white w-80 absolute md:relative shadow-sm md:w-1/5 z-50">
            <div class="flex justify-between p-4 item-center border-b border-white w-full top-0 left-0 absolute bg-black">
                <div class="flex gap-5 items-center">
                    <div class="h-10 w-10 bg-black flex items-center justify-center rounded-full text-pink-600 border border-pink-600">
                        <span class=" font-bold text-xl uppercase">{{ name == null ? "" : name.substr(0,1) }}</span>
                    </div>
                    <button> <span @click="showchangepassword=true" class=" font-bold text-xl text-pink-600 underline uppercase">{{ name }}</span></button>
                </div>
                <div class="md:hidden">
                    <button @click="showsidebar=!showsidebar"><SvgIconsVue iconname="x-mark"></SvgIconsVue></button>
                </div>
            </div>
            <div class="flex flex-col overflow-y-scroll h-screen">
                <div class="mt-20"></div>
                <router-link v-if="access.DASHBOARD" to="/" :class="{ 'bg-pink-900 text-white':appname=='DashBoard' }" class="p-5 mb-1 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'chart-bar'"></SvgIconsVue>
                    DashBoard
                </router-link>
                <router-link  v-if="access.MEMBERSHIP" to="/membership" :class="{ 'bg-pink-900 text-white':appname=='Membership' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'user-group'"></SvgIconsVue>
                    Memberships
                </router-link>
                <router-link v-if="access.PLAN" to="/menuitems" :class="{ 'bg-pink-900 text-white':appname=='Plan' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'tag'"></SvgIconsVue>
                    Plan
                </router-link>
                <router-link v-if="access.DISCOUNTS" to="/discount" :class="{ 'bg-pink-900 text-white':appname=='Discounts' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'hashtag'"></SvgIconsVue>
                    Discounts
                </router-link>
                <router-link v-if="access.BIOMETRICS" to="/employeefiles" :class="{ 'bg-pink-900 text-white':appname=='Biometrics' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'user-circle'"></SvgIconsVue>
                    Biometrics
                </router-link>
                <router-link v-if="access.COACHDUTY" to="/coachduty" :class="{ 'bg-pink-900 text-white':appname=='Coach Duty' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'clock'"></SvgIconsVue>
                    Coach Duty
                </router-link>
                <router-link v-if="access.COACHATTENDANCE" to="/coachattendance" :class="{ 'bg-pink-900 text-white':appname=='Coach Attendance' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'clipboard-document'"></SvgIconsVue>
                    Coach Attendance
                </router-link>
                <router-link v-if="access.CLASS" to="/class" :class="{ 'bg-pink-900 text-white':appname=='Class' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'queue-list'"></SvgIconsVue>
                    Class
                </router-link>
                <router-link v-if="access.MERCHANDISEPRODUCT" to="/merchandiseproduct" :class="{ 'bg-pink-900 text-white':appname=='Merchandise Products' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'archive-box'"></SvgIconsVue>
                    Merchandise Product
                </router-link>
                <router-link v-if="access.MERCHANDISEPRODUCTGROUP" to="/merchandiseproductgroup" :class="{ 'bg-pink-900 text-white':appname=='Merchandise Product Group' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'cog'"></SvgIconsVue>
                    Merchandise Product Group
                </router-link>
                <router-link  v-if="access.PHYSICALCOUNT" to="/physicalcount" :class="{ 'bg-pink-900 text-white':appname=='Merchandise Product Physical Count' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'check'"></SvgIconsVue>
                    Physical Count
                </router-link>
                <router-link v-if="access.POS" to="/pos" :class="{ 'bg-pink-900 text-white':appname=='POS' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'currency-dollar'"></SvgIconsVue>
                    POS
                </router-link>
                <router-link  v-if="access.REPORTS" to="/reports" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'paper-clip'"></SvgIconsVue>
                    Reports
                </router-link>
                <router-link v-if="access.ROLES" to="/roles" :class="{ 'bg-pink-900 text-white':appname=='Roles' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'user'"></SvgIconsVue>
                    Roles
                </router-link>
                <router-link v-if="access.USERS" to="/users" :class="{ 'bg-pink-900 text-white':appname=='Users' }" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'users'"></SvgIconsVue>
                    Users
                </router-link>
                <div class="mt-20"></div>
            </div>
            <div class="absolute inset-x-0 bottom-0 bg-black">
                <hr>
                <a href="#" @click="logout()" class="p-5 hover:bg-pink-900 hover:text-white uppercase flex items-center justify-start gap-3">
                    <SvgIconsVue :iconname="'arrow-left-on-rectangle'"></SvgIconsVue>
                    Logout
                </a>
            </div>
        </aside>
        <main class="md:w-4/5 w-full relative max-h-screen">
            <div class="p-5 flex shadow-md items-center justify-between gap-5 text-pink-600 w-full absolute">
                <div class="flex items-center gap-2">
                    <div class="md:hidden flex items-center font-bold">
                        <button @click="showsidebar=!showsidebar">
                            <SvgIconsVue iconname="bars-3"></SvgIconsVue>
                        </button>
                    </div>
                    <span class="text-xl uppercase font-bold">{{ appname }}</span> 
                </div>
                <slot class="bg-red-100" name="toolbutton"></slot>
            </div>
            <div class="mt-24 h-screen overflow-y-scroll">
                <slot name="main"></slot>
                <div class="mt-24"></div>
            </div>
            <ChangePasswordVue :showModal="showchangepassword" @onClose="showchangepassword=false"></ChangePasswordVue>
        </main>
    </div>
</template>

<script>

import SvgIconsVue from '@/components/SvgIcons.vue'
import membership from '@/mixin/membership'
import ChangePasswordVue from '@/components/forms/ChangePassword.vue'

export default{
    mixins:[membership],
    props:{
        appname: String
    },
    components:{
        SvgIconsVue,
        ChangePasswordVue
    },
    data(){
        return{
            showsidebar: true,
            name: null,
            showchangepassword: false
        }
    },
    mounted(){
        if(localStorage.getItem("token") != null){
            this.getcurrentuser()
            this.name = localStorage.name
        }
    },
    methods:{
        async getcurrentuser(){
            await this.axios.get("User/get-currentuser").then((response) => {
                if(response.data.user == null){
                    this.logout()
                }
            }).catch(() => {
                this.logout()
            })
        },

        logout(){
            localStorage.removeItem("token");
            localStorage.removeItem("name");
            localStorage.removeItem("cashierid");
            window.location.href = this.loginurl
        }
    }
}

</script>
